import { registerEnumType } from 'type-graphql'

export enum ScanDetailKindEnum {
  BatchScan = 'BatchScan',
  SingleScan = 'SingleScan',
  AnswerKey = 'AnswerKey',
  NoScanLinked = 'NoScanLinked',
}

registerEnumType(ScanDetailKindEnum, {
  name: 'ScanDetailKindEnum',
  description: 'Which kind of scan an AI usage row points at, or that it points at none',
})
